import { ChevronDown, Plus, Check } from "lucide-react";

import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";

export default function BrandSwitcher() {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <button
                    type="button"
                    className="group inline-flex items-center gap-1.5 rounded-full border border-[#1F2A40] bg-[#111726] px-3 py-1 text-xs text-[#E8ECF5] transition-colors hover:border-[#00F5D4]/40 hover:text-[#00F5D4]"
                    data-testid="brand-switcher-trigger"
                >
                    <span className="inline-flex items-center gap-1.5">
                        <span className="h-1.5 w-1.5 rounded-full bg-[#00F5D4]" />
                        Personal
                    </span>
                    <ChevronDown className="h-3 w-3 opacity-70" />
                </button>
            </PopoverTrigger>
            <PopoverContent
                align="start"
                className="z-50 w-[260px] border-[#1F2A40] bg-[#111726] p-2 text-[#E8ECF5]"
                data-testid="brand-switcher-popover"
            >
                <button
                    type="button"
                    className="flex w-full items-center justify-between rounded-md bg-[#1A2235] px-2.5 py-1.5 text-sm text-[#E8ECF5]"
                    data-testid="brand-personal"
                >
                    <span className="inline-flex items-center gap-2">
                        <span className="h-1.5 w-1.5 rounded-full bg-[#00F5D4]" />
                        Personal
                    </span>
                    <Check
                        className="h-3.5 w-3.5 text-[#00F5D4]"
                        strokeWidth={3}
                    />
                </button>
                <button
                    type="button"
                    disabled
                    className="mt-1 flex w-full cursor-not-allowed items-center justify-between rounded-md px-2.5 py-1.5 text-sm text-[#8A93A6] opacity-70"
                    data-testid="brand-add-disabled"
                >
                    <span className="inline-flex items-center gap-2">
                        <Plus className="h-3 w-3" />
                        Add brand
                    </span>
                    <span className="rounded-full border border-[#00F5D4]/40 bg-[#00F5D4]/10 px-1.5 py-0.5 font-mono text-[9px] uppercase tracking-[0.22em] text-[#00F5D4]">
                        pro
                    </span>
                </button>
                <p
                    className="mt-2 px-1 font-mono text-[10px] italic leading-relaxed text-[#8A93A6]"
                    data-testid="brand-switcher-footer"
                >
                    Multi-brand management is a Pro feature. Coming soon.
                </p>
            </PopoverContent>
        </Popover>
    );
}
